<template>
</template>

<script>
  export default {
    name: "RedirectPage",
    mounted() {
      // 这里将 URL 地址修改为你想要重定向的目标地址
      window.location.href = 'http://183.230.224.176:9005/CQJGPT/rest/oauth2/authorize?client_id=7e38889d-3cb9-4e81-98d4-101d20d628db&response_type=code' +
        '&redirect_uri=https://3531e89y62.imdo.co/#/singleLogin/';
    },
  };
</script>



// WEBPACK FOOTER //
// src/views/singleLogin/RedirectPage.vue